import { BBookableTypeEnum } from '@/types/backend';
export const EXPERIENCE_TYPES = [BBookableTypeEnum.Activity];
